// @noflow
import { GET_APP_SETTINGS, RECEIVE_APP_SETTINGS, SET_APP_SETTINGS } from './constants';

import { fromJS } from 'immutable';
import { handleActions } from 'redux-actions';
import handleReduce from '~/core/state/handle-reduce';

const actionHandlers = {
    [SET_APP_SETTINGS]: handleReduce((state, { payload }) => {
        const nextSettings = state.get('settings').merge(fromJS(payload));
        return state.set('settings', nextSettings);
    }),
    [GET_APP_SETTINGS]: handleReduce(state => state.set('loading', true)),
    [RECEIVE_APP_SETTINGS]: handleReduce((state, { payload }) =>
        state.withMutations(state => state.set('loading', false).set('settings', fromJS(payload)))
    )
};

export default handleActions(
    actionHandlers,
    fromJS({
        settings: {},
        loading: false
    })
);



// WEBPACK FOOTER //
// ./src/core/state/app-settings/index.js